import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const BestellungServiceConfig = {
  name: "Bestellung",
  annotations: []
} as ServiceConfig;